// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1561":"d7f02935","9018":"1e2531fb"}[chunkId] + ".chunk.css";
};